module.exports = __webpack_public_path__ + "static/img/Frame 100.cf11a13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Frame 100.png
// module id = V3JS
// module chunks = 1